
import { defineComponent } from 'vue';
import ApplyInvoice from './components/invoices/ApplyInvoice.vue';
import ListInvoice from './components/invoices/ListInvoice.vue';

export default defineComponent({
  components: {
    ApplyInvoice,
    ListInvoice,
  },
  data() {
    return {
      activeName: 'apply',
    };
  },
});
